// extracted by mini-css-extract-plugin
export default {"UnderlineNavContainer":"IndexAndSearchContent-module__UnderlineNavContainer__MFR7PRF"};